export enum customerTypeEnum {
  COMPANY = "company",
  PRIVATE_PERSON = "privatePerson"
}
